var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jz-container',_vm._g({staticClass:"outline-button"},_vm.$listeners),[_vm._t("default",[_vm._v("Default outline-button text")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }